/**
 * Splits a search query into whitespace-separated tokens.
 */
export function tokenize(query: string | null | undefined): string[] {
  return query?.trim().split(/\s+/).filter(Boolean) ?? [];
}
